import { render, staticRenderFns } from "./CertificationDocumentManager.vue?vue&type=template&id=4d3f804e&scoped=true"
import script from "./CertificationDocumentManager.vue?vue&type=script&lang=js"
export * from "./CertificationDocumentManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3f804e",
  null
  
)

export default component.exports